import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=bbcb08cc&scoped=true&"
import script from "./FormRadio.vue?vue&type=script&lang=js&"
export * from "./FormRadio.vue?vue&type=script&lang=js&"
import style0 from "./FormRadio.vue?vue&type=style&index=0&id=bbcb08cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb08cc",
  null
  
)

export default component.exports